import { common_urls_cws2 } from 'src/environments/environment';

export const SURRENDER_REQUEST_FORM_MAILING_BASE_ROUTE = 'surrender-request-form-mailing';

export const SURRENDER_REQUEST_FORM_MAILING_ROUTES = {
  DETAILS: 'details',
  SUBMISSION: 'submission',
  CONFIRMATION: 'confirmation',
} as const;

export const SURRENDER_REQUEST_FORM_MAILING_STEP_NAMES = ['details', 'submission', 'confirmation'] as const;
export const SURRENDER_REQUEST_FORM_MAILING_STEPPER_TRANSLATION_PREFIX = 'surrenderRequestFormMailing.stepper.';

export const SURRENDER_REQUEST_FORM_MAILING_STEP_INDEX = {
  DETAILS: 0,
  SUBMISSION: 1,
  CONFIRMATION: 2,
} as const;

export const SURRENDER_REQUEST_FORM_MAILING_API_URLS = {
  LOAD: `${common_urls_cws2.bffBaseUrl_mvp3}/load/surrender-request-form-mailing-TnC`,
  LOAD_BILLING_SCREEN: `${common_urls_cws2.bffBaseUrl_mvp3}/load/surrender-request-form-mailing-billingScreen`,
  SUBMIT: `${common_urls_cws2.bffBaseUrl_mvp3}/submit/surrender-request-form-mailing`,
} as const;
